import { erpApi } from "@/shared/axios";
import { ROUTER_PATHS, urlBackend } from "@/shared/constants";
import { AlertSeverityEnum, IDataProspectoCorporativoParams, IFromProspecto, UseMutationsParams } from "@/shared/interfaces";
import { IProspectoCorporativo, IProspectoCorporativoResp } from "@/shared/interfaces/erp/prospecto/prospecto_corporativo.interface";
import { getUrlParamsFetch, handleAxiosError } from "@/shared/utils";
import { useUiStore } from "@/store/ui";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

const { post, get, put } = erpApi();

///* Obtener todo los prospecto corporativos

export const useGetProspectoCorporativo = (params: IDataProspectoCorporativoParams, enabled: boolean = true) => {
  return useQuery({
    queryKey: ['prospectocorporativo', ...Object.values(params || {})],
    queryFn: async () => {
      return await getProspectoCorporativo(params);
    },
    retry: false,
    enabled,
    refetchOnWindowFocus: false,
  });
};

export const getProspectoCorporativo  = async (params?: IDataProspectoCorporativoParams) => {
  const queryParams = getUrlParamsFetch(params || {});
  const resp = get<IProspectoCorporativoResp>(
    `${urlBackend}api/v1/prospectocorporativo/?${queryParams}`,
    true
  );
  return resp;
};

export const getProspectoCorporativoEspecial  = async (params?: IDataProspectoCorporativoParams) => {
  const queryParams = getUrlParamsFetch(params || {});
  const resp = get<IProspectoCorporativoResp>(
    `${urlBackend}api/v1/prospectocorporativo-paginador/?${queryParams}`,
    true
  );
  return resp;
};


export const validateSellByOtherUser  = async (params?: {identificacion?:string}) => {
  const queryParams = getUrlParamsFetch(params || {});
  const resp = get<any>(
    `${urlBackend}api/v1/validar-venta-otro-usuario/?${queryParams}`,
    true
  );
  return resp;
};


///* Obtener prospecto por uid

export const useGetProspectoByIdProspectoCorporativo = (id: string) => {
  return useQuery({
    queryKey: ['prospectocorporativo'],
    queryFn: async () => {
      return getProspectoByIdProspectoCorporativo(id);
    },
    refetchOnWindowFocus: false,
    gcTime:0
  });
};

export const getProspectoByIdProspectoCorporativo = async (id: string) => {
  const res = await get<IProspectoCorporativo>(`${urlBackend}api/v1/prospectocorporativo/${id}`, true);
  return res.data;
};

///* Guardar un prospecto corporativo
export const usePostProspectoCorporativo = ({
  navigate,
  enableSuccessAlert=true
}: UseMutationsParams) => {
  const queryClient = useQueryClient();

  const setAlert = useUiStore.getState().setAlert;
  const setConfirmDialog = useUiStore.getState().setConfirmDialog;
  const setConfirmDialogIsOpen = useUiStore.getState().setConfirmDialogIsOpen;

  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;


  return useMutation({

    mutationFn: postProspectoCorporativo,
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey: ['prospectocorporativo'] });
      if (enableSuccessAlert && data.code == 200) {
        setConfirmDialogIsOpen(true);
        setConfirmDialog({
          isOpen: true,
          title: '¡Prospecto creado con éxito!',
          subtitle:
            'El prospecto se ha creado exitosamente. El siguiente paso es proceder con la creación de una preventa. ¿Deseas continuar?',
          onClose() {
            window.location.reload();
          },
          onConfirm() {
            setConfirmDialogIsOpen(false);
            navigate && navigate(`${ROUTER_PATHS.ventasCorporativas.preventaCorporativoCrearNav}/${data.data.id_prospecto_corporativo}`);
          },
          cancelTextBtn: 'Cerrar',
        });
        return;
      }

      setAlert(true, data.message, data.status);
    },

    onError: (e => {
      setIsGlobalLoading(false);
      handleAxiosError(e);
    }),
  });
};

export const postProspectoCorporativo = async (data: IFromProspecto) => {
  const res = await post<IProspectoCorporativo>(`${urlBackend}api/v1/prospectocorporativo/`, data, true);
  return res;
};

///* Actualizar propecto corporativo

export const usePutProspectoCorporativo = ({
  enableAlert = false
}: UseMutationsParams) => {

  const setAlert = useUiStore.getState().setAlert;

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: {
      id: string;
      data: IDataProspectoCorporativoParams;
    }) => {
      return putProspectoCorporativo(params);
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['prospectocorporativo'] });

      enableAlert && setAlert(true, data.message, AlertSeverityEnum.success)
    },
    onError: (error) => {
      handleAxiosError(error);
    }
  });
};

export const putProspectoCorporativo = async (
  { id, data }: {
    id: string,
    data: IDataProspectoCorporativoParams
  }
) => {
  const res = await put<IProspectoCorporativo>(`${urlBackend}api/v1/prospectocorporativo/${id}/`, data, true);
  return res;
};